import Route from '@ember/routing/route'
import type ReportingUiScopeRoute from 'teacher-ui-client/reporting/ui-scope/route'
import { toRequestScope } from 'teacher-ui-client/services/reporting'

export default class ReLessonPerformanceRoute extends Route {
  queryParams = {
    selectedLesson: {
      replace: true,
      refreshModel: false,
    },
    sort: {
      replace: true,
      refreshModel: false,
    },
    pageNumber: {
      replace: true,
      refreshModel: false,
    },
    perPage: {
      replace: true,
      refreshModel: false,
    },
  }

  model() {
    const { scopedData, uiScope, period } = this.modelFor('reporting.ui-scope') as ModelFor<ReportingUiScopeRoute>
    const requestScope = toRequestScope(uiScope)

    return {
      requestScope,
      scopedStudents: scopedData.students,
      period,
    }
  }
}
